var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sac-color-picker-container"},[_c('button',{staticClass:"sac-picker-button",on:{"click":_vm.toggleShow}},[_c('div',{staticClass:"sac-color-code"},[_vm._v(" "+_vm._s(_vm.color)+" ")]),_c('div',{staticClass:"sac-sample-block",style:(_vm.sampleStyles)})]),_c('div',{class:[
      _vm.showPicker && 'show',
      'sac-picker-container',
    ]},[_c('Chrome',{attrs:{"value":_vm.color},on:{"input":({ hex }) => _vm.change(hex)}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }